import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let questionId = useDataValue({
    context: 'question',
    viewPath: props.viewPath,
    path: 'id',
  })

  let usePatientPhone = useDataValue({
    context: 'contactDetails',
    viewPath: props.viewPath,
    path: 'phoneDetails.responsiblePersonPhoneDetails.usePatientPhone',
  })

  return (
    <View
      {...props}
      disabled={
        questionId === 'responsiblePersonContactDetails' && usePatientPhone
      }
    />
  )
}
